import {setSystemToLowercase} from './shared/serverFunctions';
import Config from './messages';

/**
 * POS User Types
 *
 * GET_LIST, GET_ONE, GET_MANY, GET_MANY_REFERENCE, CREATE, UPDATE, DELETE
 */
export const RESOURCES = {
    "POSUserTypes": {
        GET_LIST: function (params) {
            return {
                "type": "list",
                "method": "GET",
                "title": "POS User Types",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/PosUserDomainManager/posUserTypes/?params=" + JSON.stringify(params)
            }
        },
    },
    "POSUsers": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            let uri;
            if (params && params.filter && params.filter.filter_by === 'filter_location') {
                uri = localStorage.getItem('server') + "/api/v5/admin/getPosUsersbyLocationId/" + system + "/" + params.filter.filter_location
            } else if (params && params.filter && params.filter.filter_by === 'filter_level') {
                uri = localStorage.getItem('server') + "/api/v5/admin/getPosUsersbyLevel/" + system + "/" + params.filter.filter_level
            }
            return {
                "type": "list",
                "method": "GET",
                "title": "POS User Types",
                "uri": uri
            }
        },
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "item",
                "method": "GET",
                "title": "POS User",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/PosUserDomainManager/posUserById/" + system + "/" + params.id
            }
        },
        CREATE: function (params) {
            params.data.system = setSystemToLowercase();
            let posUserParams = populatePosUserParams(params, true);
            return {
                "type": "upsert",
                "data": posUserParams.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/createPosUser"
            }
        },
        UPDATE: function (params) {
            params.data.system = setSystemToLowercase();
            let posUserParams = populatePosUserParams(params, false);
            return {
                "type": "upsert",
                "data": posUserParams.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/editPosUser"
            }
        }
    }
};

/*
 * Populate values for POS Users
 */
const populatePosUserParams = (params, is_creating = false) => {
    // Populate the required fields
    const level = params.data.level;
    // Only District Managers have Districts, and only Store Managers and below have Locations
    if (level === 4) {
        params.data.location_id = null;
        params.data.district_id = null;
    } else if (level === 3) {
        params.data.location_id = null;
    } else {
        params.data.district_id = null;
    }
    if (level > 0) {
        params.data.expires_eos = false;
    }
    if (params.data.location_id) {
        params.data.location_id = params.data.location_id.toString();
    }
    // Set "admin" clientUdt
    const clientUdt = {
        system: localStorage.getItem('system'),
        location: Config.fuse.client.location,
        register: Config.fuse.client.register,
        user: localStorage.getItem('email'),
        device: Config.fuse.client.device,
        version: Config.fuse.admin.version
    };
    if (is_creating) {
        params.data.created_by_client = clientUdt;
    } else {
        params.data.modified_by_client = clientUdt;
    }

    return params;
};

export default (type, resource, params) => {

    /**
     * @param {string} type Request type, e.g. GET_LIST
     * @param {string} resource Resource name, e.g. "DBAs"
     * @param {Object} payload Request parameters. Depends on request type
     * @returns {Object} RESOURCES object
     */
    return (type, resource, params) => {
        return RESOURCES;
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/fuseUserResourceMap.js